import $http from './http'
import config from './config'
export default {
    name: 'trafficpolicy',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getAddress(data) {
        return $http.post(this.getUrl('/product/QueryAddress'), data);
    },
    CreatePolicy(data){
        return $http.post(this.getUrl('/trafficPolicy/CreatePolicy'),data)
    },
}



// WEBPACK FOOTER //
// ./src/apis/trafficPolicyApi.js